export default __webpack_public_path__ + "static/broderie.cover-8226fdf0216acb65d95daea384cdac1b.jpg";